document.addEventListener("DOMContentLoaded", function(){ // Handler when the DOM is fully loaded
    // Animate on scroll (require \bower_components\aos\dis\aos.js)
    /*AOS.init({
        offset: 150,
        once: true,
        disable: 'mobile',
        duration: 800,
        easing: 'ease-out-quad',
        delay: 100
    });

    window.addEventListener('scroll', function() {
        AOS.refresh();
    });*/
});